import { render, staticRenderFns } from "./QuestionDocumentsEditComponent.vue?vue&type=template&id=08122f0f&"
import script from "./QuestionDocumentsEditComponent.vue?vue&type=script&lang=js&"
export * from "./QuestionDocumentsEditComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports